import React from 'react';
import { Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '& .MuiDivider-root': {
      marginTop: theme.spacing(1),
    },
  },
}));

const GridGap = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.root}>
      <Divider />
    </Grid>
  );
};

export default GridGap;
